import { Component, h } from '@monygroupcorp/microact';

// Add event name constants
const EVENTS = {
    UPDATE: {
        PRICE: 'price:updated',
        STATUS: 'price:status'
    }
};

export class PriceDisplay extends Component {
    constructor(props) {
        super(props);
        this.eventBus = props.eventBus;
        this.state = {
            price: props.price || 0,
            lastUpdated: props.lastUpdated || null,
            loading: props.loading !== undefined ? props.loading : true,
            error: props.error || null
        };
    }

    didMount() {
        if (this.eventBus) {
            this.subscribe(EVENTS.UPDATE.PRICE, this.bind(this.handlePriceUpdate));
            this.subscribe(EVENTS.UPDATE.STATUS, this.bind(this.handleStatusUpdate));
        }
    }

    handlePriceUpdate({ price }) {
        this.setState({
            price: price || 0,
            loading: false
        });
    }

    handleStatusUpdate({ loading, error }) {
        this.setState({ loading, error });
    }

    render() {
        const { price, lastUpdated, loading, error } = this.state;

        if (loading) {
            return h('div', { className: 'price-display loading marble-bg' },
                h('div', { className: 'price-header' },
                    h('h3', null, 'Cult Exec '),
                    h('h3', null, 'Bonding Curve Presale')
                ),
                h('div', { className: 'price-content' },
                    h('div', { className: 'loading-indicator' }, 'Loading...')
                )
            );
        }

        if (error) {
            return h('div', { className: 'price-display error marble-bg' },
                h('div', { className: 'price-header' },
                    h('h3', null, 'Cult Exec '),
                    h('h3', null, 'Bonding Curve Presale')
                ),
                h('div', { className: 'price-content' },
                    h('div', { className: 'error-message' }, `Error: ${error}`)
                )
            );
        }

        return h('div', { className: 'price-display marble-bg' },
            h('div', { className: 'price-header' },
                h('h3', null, 'Cult Exec '),
                h('h3', null, 'Bonding Curve Presale')
            ),

            h('div', { className: 'price-content' },
                h('div', { className: 'price-value' },
                    h('span', { className: 'amount' }, Number(price).toFixed(8)),
                    h('span', { className: 'currency' }, 'ETH / Cult Exec')
                )
            )
        );
    }

    // Add component styles
    static get styles() {
        return `
            .price-display {
                background: #1a1a1a;
                border-radius: 8px;
                padding: 16px;
                margin-bottom: 16px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            }

            .price-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 12px;
            }

            .price-header h3 {
                margin: 0;
                color: var(--price-display-header-color, var(--color-text-primary, #333));
                font-size: 16px;
            }

            .last-updated {
                color: #666;
                font-size: 12px;
            }

            .price-content {
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 48px;
            }

            .price-value {
                font-size: 24px;
                font-weight: bold;
                color: #fff;
            }

            .amount {
                margin-right: 8px;
            }

            .currency {
                color: var(--price-display-currency-color, var(--color-accent, #764ba2));
            }

            .loading-indicator {
                color: #666;
                font-style: italic;
            }

            .error-message {
                color: #ff4444;
                font-size: 14px;
            }

            /* Loading state animation */
            .price-display.loading .price-content {
                opacity: 0.7;
            }

            .price-display.loading .loading-indicator:after {
                content: '';
                animation: loading-dots 1.5s infinite;
            }

            @keyframes loading-dots {
                0% { content: '.'; }
                33% { content: '..'; }
                66% { content: '...'; }
            }

            /* Error state styles */
            .price-display.error {
                border: 1px solid #ff4444;
            }

            /* Mobile responsive styles */
            @media (max-width: 768px) {
                .price-display {
                    margin: 8px;
                    padding: 12px;
                }

                .price-header {
                    flex-direction: column;
                    align-items: flex-start;
                }

                .last-updated {
                    margin-top: 4px;
                }

                .price-value {
                    font-size: 20px;
                }
            }
        `;
    }
}
